export const checked =
  'M 239,17.00001 239,239 l -221.999999,0 0,-221.99999 M 256,1.08e-5 0,1.08e-5 0,256 256,256 256,1.08e-5 Z M 31.700001,142.70001 57.5,116.80001 l 38.800001,38.9 L 198.5,53.500013 225,80.000013 97.300001,207.7 l -65.6,-64.99999 z'
